import { Box, Breadcrumbs, Link, Stack, Typography } from "@mui/material";
import type { ReactNode } from "react";
import { Link as RouterLink } from "react-router-dom";

import { HelpButton } from "./HelpButton";

export type Crumb = { label: string; to?: string };

export function PageHeader({
  title,
  subtitle,
  crumbs = [],
  actions,
  help,
}: {
  title: string;
  subtitle?: string;
  crumbs?: Crumb[];
  actions?: ReactNode;
  /** Markdown from the feature's HELP.md (`import help from "./HELP.md?raw"`); renders a uniform help icon by the title. */
  help?: string;
}) {
  return (
    <Box sx={{ mb: 2 }}>
      {crumbs.length > 0 && (
        <Breadcrumbs sx={{ mb: 0.5, fontSize: 12 }}>
          {crumbs.map((c) =>
            c.to ? (
              <Link key={c.label} component={RouterLink} to={c.to} underline="hover" color="inherit">
                {c.label}
              </Link>
            ) : (
              <Typography key={c.label} fontSize={12} color="text.primary">
                {c.label}
              </Typography>
            ),
          )}
        </Breadcrumbs>
      )}
      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
        <Box>
          <Stack direction="row" alignItems="center" spacing={0.5}>
            <Typography variant="h4" component="h1">
              {title}
            </Typography>
            {help && <HelpButton content={help} title={title} />}
          </Stack>
          {subtitle && (
            <Typography variant="body2" color="text.secondary">
              {subtitle}
            </Typography>
          )}
        </Box>
        {actions && <Stack direction="row" spacing={1}>{actions}</Stack>}
      </Stack>
    </Box>
  );
}
